<template lang="pug">
.wrapper
    .main-container
        HeaderGlobal(HeaderGlobalHeading="Territory Virtual" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                    header.flex.items-center.justify-between
                        .header-meta
                            h2.subheading Territory Virtual List
                        .header-cta
                            router-link.btn-primary(to="/territory-virtual/create") Add Territory Virtual
            .box__body
                .flex.items-center.justify-between.p-4.flex-col(
                    class="lg:flex-row"
                )
                    .mr-0.relative.field--search(
                        class="lg:mr-2"
                    )
                        input.field-style(id="field" type="text" v-model="keyword" placeholder="Search territory here..." @keyup="searchKeyword")
                        .absolute.inset-y-0.right-0.flex.items-center.px-2
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>

                    .flex.items-center.w-full.mt-3(
                        class="lg:w-48 lg:mt-0"
                    )
                        span.ml-2.mr-2 Show
                        .mr-2.relative.w-full
                            select.field-style#filter-record-size(@change="sizeChange($event)" v-model="items_per_page" style="min-width:80px")
                                option(v-for="(s,index) in size" :key="index" :value="s") {{ s }}
                            .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        span entries

                .table-static.w-full
                    table.table-general
                        thead
                            tr
                                th(v-for="(th,index) in tableThead" :key="index" :class="(th.number && th.number===true ? 'number' : '')+(th.action && th.action===true ? ' thead-action' : '')") {{ th.name }}
                        tbody
                            tr(v-if="load_data_status_territory_virtual_list === 'loading'")
                                td.text-center(:colspan="tableThead.length")
                                    .flex.flex-wrap.items-center.justify-center
                                        Spinner(show="true" size="48")

                            template(v-else-if="territory_virtual_list.data && territory_virtual_list.data.length > 0")
                                tr(v-for="(territory,index) in territory_virtual_list.data" :key="territory.id")
                                    td
                                        router-link.link-text(:to="'/territory-virtual/'+territory.id+'/detail'") {{ territory.name ? territory.name : '-' }}
                                        //- | {{ territory.name ? territory.name : '-' }}

                                    td(v-if="territory.target && territory.target.length > 0")
                                        .flex.items-center.list-target
                                            .list-target__avatar(v-for="target in territory.target.slice(0, 9)")
                                                .hidden {{ target.target_name }} : {{ target.msisdn && target.msisdn.length > 0 ? target.msisdn.join(', ') : '-' }}
                                                figure.w-12.h-12.overflow-hidden.rounded-full.bg-white.border-4(v-tooltip="target.target_name")
                                                    img.w-full.h-full.object-cover(
                                                        :src="target.photo ? target.photo : getDefaultImage"
                                                        @error="getDefaultImage"
                                                    )
                                            .list-target__more.w-12.h-12.overflow-hidden.rounded-full.bg-white.border-4.flex.items-center.justify-center.bg-white(v-if="territory.target.length > 10")
                                                span.text-sm +{{ territory.target.length - 10 }}
                                    td(v-else) -

                                    td
                                        p {{ territory.description ? (territory.description.length > 50 ? territory.description.substring(0, 80)+'...' : territory.description) : '-' }}

                                    td
                                        p(v-if="territory.created_at || territory.created_by") {{ territory.created_by.name?territory.created_by.name:"-" }} at {{ territory.created_at }} 
                                        p(v-else) -

                                    td
                                        p(v-if="territory.updated_at || territory.updated_by") {{ territory.updated_by.name?territory.updated_by.name:"-" }} at {{ territory.updated_at }} 
                                        p(v-else) -

                                    td(:class="territory.status.toLowerCase()==='stop' ? 'action' : 'text-right'")
                                        .flex.items-center.justify-end

                                            button.btn-small.btn-monitoring.ml-2
                                                .block(v-if="territory.status.toLowerCase()==='stop'")
                                                    div(v-on:click="monitoringAction(territory.id, territory.name, 1)" v-tooltip="'Start Monitoring'")
                                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M16 29.3334C23.3638 29.3334 29.3334 23.3638 29.3334 16C29.3334 8.63622 23.3638 2.66669 16 2.66669C8.63622 2.66669 2.66669 8.63622 2.66669 16C2.66669 23.3638 8.63622 29.3334 16 29.3334Z" stroke="#8997A9" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <path d="M12 9.83167C12 9.0405 12.8752 8.56266 13.5408 8.99049L23.1359 15.1588C23.7483 15.5525 23.7483 16.4475 23.1359 16.8412L13.5408 23.0095C12.8752 23.4373 12 22.9595 12 22.1683V9.83167Z" fill="#8997A9"/>
                                                        </svg>
                                                .block(v-else)
                                                    div(v-on:click="monitoringAction(territory.id, territory.name, 0)" v-tooltip="'Stop Monitoring'")
                                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M16 29.3334C23.3638 29.3334 29.3333 23.3638 29.3333 16C29.3333 8.63622 23.3638 2.66669 16 2.66669C8.63619 2.66669 2.66666 8.63622 2.66666 16C2.66666 23.3638 8.63619 29.3334 16 29.3334Z" stroke="#D71F1F" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <rect x="10.6667" y="10.6667" width="10.6667" height="10.6667" rx="1" fill="#D71F1F"/>
                                                        </svg>

                                            template(v-if="territory.status.toLowerCase()==='stop'")
                                                //- router-link.btn-icon.btn-icon-40(:to="'/territory-virtual/'+territory.id+'/detail'" v-tooltip="'Detail'")
                                                    .icon-btn
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>

                                                router-link.btn-icon.btn-icon-40.m-hide(:to="'/territory-virtual/'+territory.id+'/edit'" v-tooltip="'Edit'")
                                                    .icon-btn
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>
                                                    
                                                button.btn-icon.btn-icon-40.m-hide(v-tooltip="'Delete'" @click="deleteData(territory.id, territory.name)")
                                                    .icon-btn
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                            tr(v-else)
                                td.text-center(:colspan="tableThead.length") No Data Available

                    .mt-5
                    vue-ads-pagination(
                        :total-items="total_data"
                        :items-per-page="items_per_page"
                        :page="page"
                        :max-visible-pages="5"
                    )
                        template(slot="buttons" slot-scope="props")
                            vue-ads-page-button(
                                v-for="(button, key) in props.buttons"
                                :key="key"
                                v-bind="button"
                                :class="{'bg-yellow-dark': button.active}"
                                @page-change="page = button.page"
                                @range-change="start = button.start; end = button.end"
                            )
</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from './../../components/HeaderGlobal.vue';
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import Spinner from '@/components/Spinner.vue';

export default {
    name: 'PageTerritoryVirtual',
    components: {
        HeaderGlobal,
        Spinner,
        VueAdsPagination,
        VueAdsPageButton,
    },
    data: function() {
        return {
            breadcrumb: [
                {
                    name: 'Territory Virtual',
                    url: '/territory-virtual',
                },
            ],
            advanceFilter: false, 
            dataTerritory: [
                {
                    id: 1,
                    name: `Name Virtual 1`,
                    target: "Alberto Stone",
                    desc: 'Topping jelly-o muffin danish candy canes cake brownie. Soufflé',
                    updated: '10 April 2020 13:00 WIB',
                },
            ],

            tableThead: [
                {
                    name: 'Name',
                    // number: true,
                },
                // {
                //     name: 'Point',
                // },
                {
                    name: 'Target',
                },
                {
                    name: 'Description',
                },
                {
                    name: 'Created By',
                },
                {
                    name: 'Last Updated By',
                },
                {
                    name: 'Action',
                    action: true,
                },
            ],

            total_data: 0,
            items_per_page: 10,

            size: [10, 25, 50, 100],

            page: 0,
            start: 0,
            end: 0,

            keyword: '',
            timeout: null,

            // ImgAvatar: require('../../assets/images/default-avatar.png'),
            ImgAvatar: require('../../assets/no-image-profile.jpg'),
        }
    },
    computed: {
        ...mapState([
            'load_data_status_territory_virtual_list',
            'territory_virtual_list',
        ]),
        route_name() {
            return this.$route.name;
        },
    },
    watch: {
        route_name(newData, oldData) {
            if (newData === 'PageTerritoryVirtualIndex') {
                if (oldData !== 'PageTerritoryVirtualIndex') {
                    this.items_per_page = 10;
                    this.page = 0;
                    this.keyword = '';
                    this.$store.commit('setTerritoryVirtualList', {});
                }

                this.getData();
            }
        },
        territory_virtual_list(newData) {
            // console.log(newData);
            if (Object.keys(newData).length > 0) {
                this.total_data = parseInt(newData.total_data);
                // this.page = (parseInt(newData.current_page) - 1);
            } else {
                this.total_data = 0;
            }
        },
        total_data() {
            // this.pagination();
        },
        items_per_page() {
            this.getData();
            // this.pagination();
        },
        page() {
            this.getData();
        },
        keyword() {},
    },
    methods: {
        getDefaultImage(e) {
            e.target.src = this.ImgAvatar;
        },
        getData() {
            if (this.route_name === 'PageTerritoryVirtualIndex') {
                this.$store.dispatch('getTerritoryVirtualList', [this.items_per_page, (parseInt(this.page) + 1), this.keyword]);

                // if (this.territory_virtual_list.total_page && this.territory_virtual_list.total_page > 1) {
                    // console.log(this.territory_virtual_list.total_page)
                    this.pagination();
                // }
            }
        },
        monitoringAction(id, territory_name, status=1,) {
            // console.log(this.monitoringTarget.length)
            var confirm = true
            var title = 'Are you sure you want to start monitoring ?'
            if (status !== 1) {
                title = 'Are you sure you want to stop monitoring?'
            }

            if(confirm) {
                this.$swal.fire({
                    icon: 'warning',
                    title: title,
                    text: 'Territory Name : ' + territory_name,
                    confirmButtonText: 'Yes!',
                    confirmButtonColor: '#DD6B55',
                    showCancelButton: true,
                    allowOutsideClick: false,
                })
                .then((result) => {
                    // console.log('on result');
                    if (result.isConfirmed) {

                        this.showLoading(true);

                        this.$store.dispatch('getTerritoryVirtualUpdateStatus', [id, status])
                        .then((resp) => {
                            // console.log(resp);
                            if (resp.result === 'success') {
                                this.page = 0;

                                this.getData();

                                this.$swal.fire({
                                    icon: 'success',
                                    title: resp.data.message,
                                    timer: 3000,
                                });
                            } else {
                                if (resp.data.message) {
                                    this.error(resp.data.message);
                                } else {
                                    this.error();
                                }
                            }
                        });
                    }
                });
            }
        },
        deleteData(id, name) {
            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to delete?',
                // text: id,
                text: 'Territory : ' + name,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {

                if (result.isConfirmed) {

                    this.showLoading(true);

                    this.$store.dispatch('getTerritoryVirtualDelete', [id])
                    .then((resp) => {
                        if (resp === 'success') {
                            this.page = 0;

                            this.getData();

                            this.$swal.fire({
                                icon: 'success',
                                title: 'Data successfully deleted!',
                                timer: 3000,
                            });
                        } else {
                            if (resp.data.message) {
                                this.error(resp.data.message);
                            } else {
                                this.error();
                            }
                        }
                    });
                }
            });
        },
        pageChange(page) {
            this.page = page;
        },
        rangeChange(start, end) {
            this.start = start;
            this.end = end;
        },
        sizeChange() {
            this.page = 0;
        },
        pagination() {
            // update fontawesome to iconfont
            var paginationButtonPreview = document.getElementsByClassName("fa-angle-left");

            if (paginationButtonPreview[0]) {
                var classListPrev = paginationButtonPreview[0].classList;

                if (Object.values(classListPrev).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonPreview[0].classList.add('iconfont');
                    paginationButtonPreview[0].classList.add('iconleft');
                    paginationButtonPreview[0].style.fontSize = '12px';
                }
            }

            var paginationButtonNext = document.getElementsByClassName("fa-angle-right");

            if (paginationButtonNext[0]) {
                var classListNext = paginationButtonNext[0].classList;

                if (Object.values(classListNext).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonNext[0].classList.add('iconfont');
                    paginationButtonNext[0].classList.add('iconright');
                    paginationButtonNext[0].style.fontSize = '12px';
                }
            }
        },
        searchKeyword() {
            // clear timeout variable
            clearTimeout(this.timeout);
            
            var self = this;
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                self.page = 0;
                self.$store.commit('setTerritoryVirtualList', {});

                // if (self.keyword.length > 0) {
                    self.getData();
                // }
            }, 650);
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message=null) {
            this.$swal.fire({
                title: 'Failed!',
                text: (message!==null ? message : 'Something wrong.'),
                icon: 'error',
                // timer: 3000
            });
        },
    },
    mounted() {
        this.getData();
    },
}
</script>

<style lang="sass">

%nowrap-text
    text-overflow: ellipsis
    white-space: nowrap
    display: block
    overflow: hidden
    

.no-wrap-text-percen
    max-width: 300px
    @extend %nowrap-text

.list-target
    &__avatar
        position: relative
        margin-left: -12px
        &:first-child
            margin-left: 0px
        figure
            border-color: #22333e !important

    &__more
        margin-left: -12px
        z-index: 9
        background-color: #10191e !important
        border-color: #22333e !important

</style>


